import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import SpacedGridContainer from "~/components/SpacedGridContainer";
import SpacedGridItem from "~/components/SpacedGridItem";

const NotFound = () => {
	const { t } = useTranslation("common");
	const navigate = useNavigate();

	return (
		<SpacedGridContainer sx={{ alignContent: "center", minHeight: "90%", padding: "1em", textAlign: "center" }}>
			<SpacedGridItem maxCols={1} smMargin>
				<Typography variant="h4">{t("errorPages.notFound.title")}</Typography>
			</SpacedGridItem>
			<SpacedGridItem maxCols={1} smMargin>
				<img alt={t("errorPages.notFound.imageAlt")} src="/404-error.png" style={{ maxWidth: "55%", width: "100%" }} />
			</SpacedGridItem>
			<SpacedGridItem maxCols={1} smMargin>
				<Typography variant="h5">{t("errorPages.notFound.message")}</Typography>
			</SpacedGridItem>
			<SpacedGridItem maxCols={1} smMargin>
				<Button color="primary" onClick={() => navigate("/")} variant="contained">
					{t("errorPages.notFound.returnHome")}
				</Button>
			</SpacedGridItem>
		</SpacedGridContainer>
	);
};

export default NotFound;
